import React from 'react'
import { TextBody } from '@ally/metronome-ui'
import { Dd } from './StyledDlElements'
import { AccountDetails } from '../../../types'
import { getServerTimeShortDate } from '../../../utils/formatter'
import { TopCardItem } from '../TopCardItem'
import { pastBestRate } from '../../../utils/pastBestRate'

export const MaturesOnTopCard: React.FC<{
  account: AccountDetails
  accountClosed: boolean
}> = ({ account, accountClosed }) => {
  const accountHasBalance = account.currentBalancePvtEncrypt > 0

  return (
    <TopCardItem title="MATURES ON">
      <Dd>
        {(!accountClosed && accountHasBalance) ||
        // if CDA opening date does not exceed best rate guarantee days we should show matures on
        !pastBestRate(account) ? (
          <TextBody tag="span" size="lg" data-testid="matures-on-date">
            {account.cdMaturityDatePvtEncrypt &&
              getServerTimeShortDate(account.cdMaturityDatePvtEncrypt)}
          </TextBody>
        ) : (
          <TextBody
            tag="span"
            size="lg"
            data-testid="matures-on-account-closed"
          >
            --
          </TextBody>
        )}
      </Dd>
    </TopCardItem>
  )
}
